<template>
    <form class="school-channel__lesson-form" ref="lessonForm" @click="handleBlurSelect($event)" >
        <div class="school-channel__form-content" >
            <div class="school-channel__form-basic-info">
                <div  class="school-channel__form-item school-channel__grade-subject">
                    <div class="school-channel__form-item--content school-channel__grade">
                        <input
                            data-select="1"
                            class="school-channel__form-item--content  school-channel__school--input"
                            placeholder="请输入孩子的就读学校"
                            v-model="weakGradeLabel"
                            @change="openGradeList($event)"
                            @click="openGradeList($event)"
                            @input="openGradeList($event)"
                            @blur="hideGradeList"
                            readonly
                        />
                        <ul class="school-channel__grade--list" v-show="showGradeList">
                            <li
                                data-select="1"
                                v-for="({label, value}, index) in subjectGrade"
                                :key="label+index"
                                @click="handleSelectGrade($event, label, value)"
                                :class="['school-channel__grade--item', weakGrade === value ? 'school-channel__grade--active' : '']"
                            >{{ label }}</li>
                        </ul>
                    </div>
                    <div class="school-channel__form-item--content school-channel__subject">
                        <input
                            data-select="2"
                            class="school-channel__form-item--content  school-channel__school--input"
                            placeholder="请输入孩子的就读学校"
                            v-model="weakSubjectLabel"
                            @change="openSubjectList($event)"
                            @click="openSubjectList($event)"
                            @input="openSubjectList($event)"
                            @blur="hideSubjectList"
                            readonly
                        />
                        <ul class="school-channel__subject--list" v-show="showSubjectList">
                            <li
                                data-select="2"
                                v-for="({label, value}, index) in weakSubjectArr"
                                :key="label+index"
                                @click="handleSelectSubject($event, label, value)"
                                :class="['school-channel__subject--item', weakSubject === value ? 'school-channel__subject--active' : '']"
                            >{{ label }}</li>
                        </ul>
                    </div>
                </div>

                <div class="school-channel__form-item">
                    <input type="text" placeholder="请输入孩子的姓名" class="school-channel__form-item--content  school-channel__username" :class="{ alert: userNameAlert }" v-model="userName"  />
                </div>
                <!-- <div class="school-channel__form-item school-channel__school">
                    <input
                        data-select="3"
                        class="school-channel__form-item--content  school-channel__school--input"
                        placeholder="请输入孩子的就读学校"
                        v-model="stuSchool"
                        @change="handleSchoolChange($event)"
                        @click="openSchoolList"
                        @input="openSchoolList"
                        @blur="hideSchoolList"
                    />
                    <ul class="" v-show="showSchoolList && searchSchool.length"
                        :class="['school-channel__school--list', searchSchool.length <= 5 ? 'school-channel__school--scrollbar' : '']"
                    >
                        <li
                            data-select="3"
                            v-for="(item, index) in searchSchool"
                            :key="'school'+index"
                            @click="handleSelectSchool($event, item)"
                            :class="['school-channel__school--item', stuSchool === item.schoolName ? 'school-channel__school--active' : '']"
                        >{{ item.schoolName }}</li>
                    </ul>
                </div> -->
                <div class="school-channel__form-item">
                    <span class="area-code" >+86</span>
                    <input type="number" placeholder="请输入上课联系手机号" :class="{ alert: mobileAlert }" class="school-channel__tel school-channel__form-item--content " v-model="mobile" maxlength="11"  />
                </div>
                <div class="school-channel__form-item" >
                    <input type="number" v-model="codeNumber" placeholder="请输入验证码" class="school-channel__codeNumber school-channel__form-item--content " />
                    <div class="school-channel__send-code" @click="initGeetest">
                        {{ codeCountDown }}
                    </div>
                </div>
            </div>

        </div>

        <img class="school-channel__zm-btn" href="javascript:;" src="https://static-app-manager.zmlearn.com/WRE4Z84j7270.png" @click="handleSubmitBtn()">

        <div class="school-channel__form-protocol">
            <img :src="getCheckedIcon" @click="checkProtocol = !checkProtocol" class="school-channel__checkoutImg" alt />
            <div>
                <span @click="checkProtocol = !checkProtocol"  class="school-channel__form-protocol--text">同意我们的</span>
                <span @click.stop="showProtocol = true" class="school-channel__form-protocol--high-light">《用户隐私条款》</span>
            </div>
        </div>
        <div class="school-channel__info">
            <img class="school-channel__lock" src="https://web-data.zmlearn.com/image/vRuqLVCMvKdxPdhcoQBoCv/%E5%BD%A2%E7%8A%B6.png" />
            <span>为了您的权益，您的隐私将被严格保密</span>
        </div>
        <protocol :showProtocol.sync="showProtocol"></protocol>
    </form>
</template>

<script>
    import api from "@/api";
    import cookies from 'js-cookie';
    require("@/vendor/gt.js");
    import Geetest from "@/utils/geetest"; // 极验代码
    import {
        request,
        queryObj,
        isEmptyObject,
    } from "@/utils/util";
    import urlConfig from "@/config";
    import Protocol from "@/components/lesson-form/protocol";
    import Toast from "@/base/toast/toast";
    import {
        mapState
    } from "vuex";


    const FROM_DICT = {
        "3": {
            trigger_site: "弹窗立即购买",
            event_id: "click_kid_act_19.9_ljgm02",
            event_name: "点击|少儿|官网m端|弹窗立即购买",
            position: "弹窗立即购买",
        },
    };

    export default {
        name: "lesson-form",
        components: {
            Protocol,
        },
        data() {
            return {
                getCode: "获取验证码",
                codeCountDownNum: 60,
                codeCountSubmitNum: 3,
                areaCode: 86,
                vertifyOnOff: true, // 获取验证码按钮是否可点击
                userName: "",
                weakGrade: "PRIMARY_SCHOOL_3",
                weakSubject: "MATH_LOGIC",
                weakGradeLabel: "小三",
                weakSubjectLabel: "数理逻辑训练",
                mobile: "",
                userNameAlert: false,
                mobileAlert: false,
                checkProtocol: true,
                showProtocol: false,
                codeNumber: "",
                changMobile: false,
                weakSubjectArr: [
                    {label: '数理逻辑训练', value: 'MATH_LOGIC'},
                    {label: '语文思维训练', value: 'CHINESE_LOGIC'},
                ],
                subjectGrade:[
                    {label: '幼儿园中班', value: 'KINDERGARTEN_2'},
                    {label: '幼儿园大班', value: 'KINDERGARTEN_3'},
                    {label: '小一', value: 'PRIMARY_SCHOOL_1'},
                    {label: '小二', value: 'PRIMARY_SCHOOL_2'},
                    {label: '小三', value: 'PRIMARY_SCHOOL_3'},
                ],
                iconCheckState: {
                    checked: 'https://web-data.zmlearn.com/image/ut7ZfqyGo5aSiWmLPWCdCr/%E7%BC%96%E7%BB%84%205.png',
                    unchecked: 'https://web-data.zmlearn.com/image/7cCwbkGdtrLweuC3eEEHSw/%E6%A4%AD%E5%9C%86%E5%BD%A2.png'
                },
                isSubmitting: false,
                showSchoolList: false,
                showSubjectList: false,
                showGradeList: false,
                stuSchool: '',
                schoolList: [],
                isSelectingListState: false,
                schoolInfo: {},
                LOGINFO: {},
        };
        },
        filters: {
            filterPhoneNumber(number) {
                if (number.length === 11) {
                    let pat = /(\d{3})\d*(\d{4})/;
                    return (number = number.replace(pat, "$1****$2"));
                }
            },
        },
        watch: {
            userName() {
                this.userNameAlert = false;
            },
            mobile() {
                this.mobileAlert = false;
                this.changMobile = true;
            },
        },

        computed: {
            codeCountDown() {
                if (this.codeCountDownNum === 60 || this.codeCountDownNum <= 0) {
                    return this.getCode;
                } else {
                    return this.codeCountDownNum + "s";
                }
            },
            getCheckedIcon () {
                const { checked, unchecked } = this.iconCheckState;
                return this.checkProtocol && checked || unchecked;
            },
            // 从字典中查找与用户输入相关的学校列表
            searchSchool() {
                const s = this.stuSchool.split('');
                const aboutResult = [];
                this.schoolList.forEach((item) => {
                    const itemArr = item.schoolName.split('');
                    let isInclude = true;
                    for (let i = 0;i < s.length;  i++) {
                        isInclude = itemArr.includes(s[i]);
                        if (!itemArr.includes(s[i])) {
                            break;
                        }
                    }
                    isInclude && aboutResult.push(item);
                });
                return aboutResult;
            }
        },
        mounted() {
            this.initLogInfo(this.$route.query.channel_code);
            this.getSchoolList();
        },
        methods: {
            async sendEvent(data) {
                await ZM_JSSDK && ZM_JSSDK.sendEvent(data);
            },
            initLogInfo(code) {
                this.LOGINFO = {
                    '1': {
                        eventId: 'enter_kid_act37_success',
                        eventParam: {
                            code,
                            phone_num: this.mobile,
                        }
                    },
                    '2': {
                        eventId: 'click_kid_act37_ljlq02',
                        eventParam: {
                            code, // 点击立即领取
                        }
                    }
                }
            },
            validatePhoneNumber() {
                if (!/^\d+$/.test(this.mobile)) {
                    Toast('请输入手机号');
                    return false;
                }
                if (!/^\d{11}$/.test(this.mobile)) {
                    Toast('请填写正确手机号');
                    return false;
                }
                return  true;
            },
            // 极验
            async initGeetest() {
                if (!this.validatePhoneNumber() || !this.vertifyOnOff) { return; }
                try {
                    const captchaObj = await Geetest.request({
                        product: "bind",
                        width: "320px",
                    });
                    this.captchaObj = captchaObj;
                    captchaObj
                        .onReady(() => {
                            setTimeout(() => {
                                this.captchaObj.verify();
                            }, 100);
                        })
                        .onSuccess(async () => {
                            try {
                                const result = captchaObj.getValidate();
                                if (!result) {
                                    return Toast("请完成验证");
                                }
                                const data = {
                                    areaCode: '86',
                                    mobile: this.mobile,
                                    geetestChallenge: result.geetest_challenge,
                                    geetestValidate: result.geetest_validate,
                                    geetestSeccode: result.geetest_seccode,
                                };
                                await this.identifySubmitBtn(data);
                            } catch (e) {
                                Toast(e.message);
                                this.captchaObj = captchaObj;
                            } finally {
                                captchaObj.destroy();
                            }
                        })
                        .onError(() => {
                            Toast({
                                message: "您刷新太多次了, 故关闭验证弹框, 请从新验证",
                                duration: 2000,
                            });
                            this.vertifyOnOff = true;
                            captchaObj.destroy();
                            this.captchaObj = captchaObj;
                        })
                        .onClose(() => {
                            this.vertifyOnOff = true;
                            captchaObj.destroy();
                            this.captchaObj = captchaObj;
                        });
                } catch (e) {
                    console.warn(e);
                }

            },
            // 验证码发送成功并开始倒计时
            codeSendSuccess() {
                Toast("验证码发送成功");
                const timer = setInterval(() => {
                    this.codeCountDownNum--;
                    if (this.codeCountDownNum <= 0 || this.changMobile) {
                        clearInterval(timer);
                        this.vertifyOnOff = true;
                        this.codeCountDownNum = 60;
                        this.codeNumber = "";
                    }
                }, 1000);
            },
            // 发送验证码 验证码发送并倒计时
            async identifySubmitBtn(params) {
                if (!/^\d+$/.test(this.mobile)) {
                    return Toast("请输入手机号");
                }
                if (this.vertifyOnOff) {
                    this.vertifyOnOff = false;
                    try {
                        const {data: { code, message }} = await api.KidGetVerifyCode(params);
                        if (code * 1 === 0) {
                            this.changMobile = false;
                            this.codeSendSuccess();
                        } else {
                            this.vertifyOnOff = true;
                            Toast(message || "验证码发送失败，请稍后再试");
                        }
                    } catch (e) {
                        this.vertifyOnOff = true;
                        Toast(e);
                    }
                }
            },

            // 验证表单
            validateForm() {
                return new Promise((resolve, reject) => {
                        if (!/^([a-zA-Z]|[\u4e00-\u9fa5]){1,}$/.test(this.userName)) {
                            this.userNameAlert = true;
                            reject("请填写正确的孩子姓名");
                        } else if (this.userName.length >= 7) {
                            this.userNameAlert = true;
                            reject("请填写正确的孩子姓名");
                        } else if (this.mobile.length === 0) {
                            this.mobileAlert = true;
                            reject("请输入手机号");
                        } else if (
                            !/^\d+$/.test(this.codeNumber)
                        ) {
                            reject("请输入正确的验证码");
                        } else if (!this.checkProtocol) {
                            reject("请同意用户隐私协议");
                        } else {
                            resolve("success");
                        }
                });
            },

            // 验证表单并注册
            async handleSubmitBtn() {
                if (this.isSubmitting) { return;}
                this.isSubmitting = true;
                try {
                    await this.sendEvent(this.LOGINFO['2']);
                    await this.validateForm();
                    await this.doRegister();
                } catch (e) {
                    Toast(e);
                } finally {
                    setTimeout(
                        () => {
                            this.isSubmitting = false;
                        }, 500
                    );
                }
            },

            async loginWithCode() {
                let self = this;
                const { channel_keyword = '', channel_code = ''} = this.$route.query;
                const params = {
                    // activityId: 0,
                    weakSubjectCode: this.weakSubject,
                    stuGradeCode: this.weakGrade,
                    mobile: this.mobile,
                    credentials: this.vertifyCodeStatus ? this.identifyingCode : '',
                    code: channel_code,
                    key: channel_keyword,
                    name: this.userName,
                };
                const timer2 = setInterval(() => {
                    this.codeCountSubmitNum--;
                    if (this.codeCountSubmitNum <= 0) {
                        clearInterval(timer2);
                        this.codeCountSubmitNum = 3;
                        self.submitOnOff = true
                    } else {
                        this.submitOnOff = false
                    }
                    return this.submitOnOff
                }, 1000);

                try {
                    const {data: {code, data: {accessToken = '', status} = {}, message}} = await api.KidAppointmentWithCode(params);
                    if (code * 1 === 0) {
                        if (status === 2 && accessToken) {
                            this.redirectToOrder(accessToken);
                        } else if (status === 1) {
                            this.currentPhoneNumberHasCCOrCR = true;
                            this.currentPhoneNumber = this.mobile;
                            this.vertifyCodeStatus = false;
                            this.identifyingCode = '';
                            this.mobile = '';
                            Toast({
                                message: '当前手机号已注册，无法享受购买优惠。你可以更换新手机号重新支付哦！',
                                duration: 3000
                            })
                        } else {
                            this.identifyingCode = '';
                            Toast(message || '提交失败，请重试！')
                        }
                        !accessToken && console.error(accessToken);
                    } else {
                        this.identifyingCode = '';
                        Toast(message || '提交失败，请重试！')
                    }
                } catch (e) {
                    console.log(e);
                }
                // console.log(this.$route.query);
            },
            // 注册
            async doRegister() {
                const { channel_keyword = '', channel_code = ''} = this.$route.query;
                const { provinceName = '', cityName = '', areaName = '' } = this.schoolInfo;
                const params = {
                    activityId: 10577,
                    weakSubjectCode: this.weakSubject,
                    stuGradeCode: this.weakGrade,
                    mobile: this.mobile,
                    credentials: this.codeNumber,
                    code: channel_code,
                    key: channel_keyword,
                    name: this.userName,
                    stuSchool: this.stuSchool,
                    stuArea: areaName,
                    stuCity: cityName,
                    stuProv: provinceName,
                    appointmentValue: 3
                };
                try {
                    const {data: {code, data: {accessToken = '', status} = {}, message}} = await api.KidAppointmentWithCode(params);
                    if (code * 1 === 0) {
                        this.initLogInfo(channel_code);
                        await this.sendEvent(this.LOGINFO['1']);
                        this.$router.push({
                            name: 'appointment-success-kid',
                            params: {
                                mobile: this.mobile,
                                flatfrom: this.$route.name || '',
                                grade: this.weakGrade,
                                channel_code,
                                channel_keyword,
                                showPeilian: false
                            },
                        });
                    } else {
                        Toast(message);
                    }
                } catch (e) {
                    Toast(e);
                }
            },
            // 获取学校列表
            async getSchoolList(schoolName='') {
                try {
                    const {data: {code, data: schoolList, message}} = await api.KidGetSchoolList({schoolName});
                    code *1 === 0 && (this.schoolList = schoolList);
                } catch (e) {
                    console.log('school', e);
                }
            },
            // 选择学校
            handleBlurSelect(e) {
                const s = e.target.dataset.select;
                if ( s !== '1' && s !== '2' && s !== '3') {
                    this.isNotSelectingList();
                    this.hideSubjectList();
                    this.hideGradeList();
                    this.hideSchoolList();
                }
            },
            handleSelectSchool($event, item) {
                this.schoolInfo = item;
                this.stuSchool = item.schoolName;
                this.isNotSelectingList();
                this.hideSchoolList();
            },
            handleSelectGrade($event, grade, gradeCode) {
                this.weakGradeLabel = grade;
                this.weakGrade =  gradeCode;
                this.isNotSelectingList();
                this.hideGradeList();
            },
            handleSelectSubject($event, subject, subjectCode) {
                this.weakSubjectLabel = subject;
                this.weakSubject =  subjectCode;
                this.isNotSelectingList();
                this.hideSubjectList();
            },
            handleSchoolChange($event) {
              this.openSchoolList();
              this.schoolInfo = {
                  schoolName: this.stuSchool
              };
            },
            openSchoolList() {
                this.isNotSelectingList();
                this.hideSubjectList();
                this.hideGradeList();
                this.isSelectingList();
                this.showSchoolList = true;
            },
            hideSchoolList() {
                if (!this.isSelectingListState) {
                    this.showSchoolList = false;
                }
            },
            openSubjectList($event) {
                this.isNotSelectingList();
                this.hideSchoolList();
                this.hideGradeList();
                this.isSelectingList();
                this.showSubjectList = true;
            },
            hideSubjectList() {
                if (!this.isSelectingListState) {
                    this.showSubjectList = false;
                }
            },
            openGradeList($event) {
                this.isNotSelectingList();
                this.hideSchoolList();
                this.hideSubjectList();
                this.isSelectingList();
                this.showGradeList = true;
            },
            hideGradeList() {
                if (!this.isSelectingListState) {
                    this.showGradeList = false;
                }
            },
            isSelectingList() {
                this.isSelectingListState = true;
            },
            isNotSelectingList() {
                this.isSelectingListState = false;
            }
        },
    };
</script>

<style lang="scss" scoped>
    $theme: #ff6e35;
    $fz-protocol: px2rem(22);
    $bgColor: #fff;
    $black0: #000;
    $black3: #333;
    $black6: #666;
    $black9: #999;
    $space: px2rem(14);
    .area-code {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        margin-right: px2rem(7);
        border-radius: px2rem(20);
        padding-left: px2rem(19);
        width: px2rem(126);
        height: px2rem(86);
        background: #EEEEEE;
        font-size: px2rem(28);
        color: #999999;
        box-sizing: border-box;
    }
    @mixin utils-scrollbar-thin($width) {
        &::-webkit-scrollbar{
            width: $width;
            height: px2rem(0);
            padding-top: 0;
            &-track, &-button, &-track-piece, &-corner {
                display: none;
            }
            &-thumb {
                border-radius:4px;
                height: 0;
                border: none;
                background: #ccc;
            }
            &-track-piece {
                display: none;
            }
        }
    }
    @mixin utils-flex($align-item: center, $justify-content: center, $direction: row, $wrap: nowrap) {
        display: flex;
        align-items: $align-item;
        justify-content: $justify-content;
        flex-flow: $direction $wrap;
    }
    .school-channel{
        &__lesson-form {
            overflow: hidden;
            width: 100%;
            background: url('https://web-data.zmlearn.com/image/mfYVfucEqjEc22vNYqXnai/form_bg.png') no-repeat 0 0;
            background-size: 100% 100%;
        }
        &__form-content {
            margin-top: px2rem(178);
        }
        &__form-item {
            width: 100%;
            padding: 0 px2rem(32) px2rem(16);
            box-sizing: border-box;
            @include utils-flex;
            &--content{
                width: 100%;
                height: px2rem(86);
                padding: 0 px2rem(20);
                border-radius: px2rem(20);
                border: none;
                box-sizing: border-box;
                color: #202020;
                background: #eee;
                font-size: px2rem(28);

                &::placeholder {
                    color: #999;
                }
            }
        }
        &__grade-subject {
            justify-content: space-between;
        }
        &__grade,
        &__subject,
        &__school{
            position: relative;
            width: 48%;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            padding: 0 px2rem(30) 0 px2rem(20);
            font-size: px2rem(28);
            &--input {
                position: relative;
                z-index: 4;
                background: url('https://web-data.zmlearn.com/image/8kzGTUynStSU5ZM1u8uSqm/arrow_03.png') 95% center no-repeat  transparent;
                background-size: px2rem(26) px2rem(16);
                background-color: #eee;
            }
            &--list {
                position: absolute;
                top: px2rem(86);
                left: 0;
                z-index: 5;
                width: px2rem(623);
                margin: 0 px2rem(32);
                box-sizing: border-box;
                border: 1px solid #b6924d;
                background-color: #eee;
            }
            &--item {
                display: flex;
                align-items: center;
                padding-left: px2rem(16);
                height: px2rem(80);
                color: #202020;
            }
            &--active {
                background-color: #a3d7eb;
                color: #fff;
            }
        }
        &__grade,
        &__subject {
            &--list {
                width: px2rem(300);
                margin: 0;
            }
        }
        &__school {
            width: 100%;
            padding: 0 px2rem(32) px2rem(16);
            background-color: transparent;
            &--list {
                max-height: px2rem(400);
                overflow: scroll;
                @include utils-scrollbar-thin(3px);
            }
            &--scrollbar {
                @include utils-scrollbar-thin(0);
            }
        }
        &__title {
            font-size: px2rem(55);
            padding: px2rem(40);
            color: $theme;
        }
        &__send-code {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            right: px2rem(60);
            border-radius: px2rem(10);
            width: px2rem(181);
            height: px2rem(66);
            background: #FF7533;
            font-size: px2rem(28);
            color: #fff;
        }
        &__form-protocol {
            @include utils-flex;
            &--text {
                font-size: $fz-protocol;
                color: #2B2B2B;
            }
            &--high-light {
                font-size: $fz-protocol;
            }
            &--high-light {
                color: $theme;
            }
        }
        &__checkoutImg {
            width: px2rem(26);
            margin-right: $space;
        }
        &__lock {
            width: px2rem(18);
            margin-right: $space;
        }
        &__info {
            margin: px2rem(20) 0;
            color: #575757;
            font-size: px2rem(22);
        }
        &__zm-btn {
            width: px2rem(634);
            height: px2rem(138);
        }
    }

</style>
